import { getManifestFormFields } from "./hooks/manifest";
import { VARIABLE_MODEL } from "src/utils/constants/variable";
import groupBy from "lodash/groupBy";
import compact from "lodash/compact";
import startCase from "lodash/startCase";

const formatFieldVariableLabel = ({ field, variable }) => {
  /**
   * Replace the value root as thats not useful from a client side reader point of view
   */
  const additionalLabel = variable.path.replace(/^(value.|value)/, "");
  return startCase(
    compact([field.label, ...additionalLabel.split(".")]).join(" ")
  );
};

/**
 * UUID for dynamic variables is set as {field.uuid}:{variable.path}
 * {
 *   uuid: null,
 *   label: "Tax id",
 *   model: "checkout.form_data",
 *   modelUid: "tin",
 *   path: "value",
 *   service: "priceblocs"
 * }
 */
const prepareFormFieldVariable = ({ field, variable }) => {
  return {
    ...variable,
    /**
     * Setup the uuid so that it can share a uuid but be differentiated by path
     */
    uuid: `${field.uuid}:${variable.path}`,
    label: formatFieldVariableLabel({ variable, field })
  };
};

const prepareFormFieldVariables = ({ fields, variables }) => {
  const result = [];

  for (let index = 0; index < fields.length; index++) {
    const field = fields[index];
    const matching = variables[field.uid];
    if (matching) {
      for (let varIx = 0; varIx < matching.length; varIx++) {
        const variable = matching[varIx];

        result.push(prepareFormFieldVariable({ variable, field }));
      }
    }
  }

  return result;
};

export const prepareManifestVariables = ({ manifest, variables }) => {
  const fields = getManifestFormFields({ manifest });
  const formVariables = groupBy(
    variables.filter(
      ({ model }) => model === VARIABLE_MODEL.CHECKOUT_FORM_DATA
    ),
    "modelUid"
  );

  const result = prepareFormFieldVariables({
    fields,
    variables: formVariables
  });

  return result;
};

export const ensureValidVariableSample = ({ field, variable }) => {
  return field.uid === "email" &&
    /email/i.test(variable.label) &&
    !/@/.test(variable.sample)
    ? "customer@company.com"
    : variable.sample;
};
